import { parseTokenStateContext } from "@authe/contract-explorer";
import { transactionFocusFromHint } from "../transactions/transactionTabs";
/** TanStack may parse bare numeric query parameters as numbers. */
export function contractSearch(search: Record<string, unknown>): { block?: string; before?: string; tab?: string; tx?: string; txFocus?: string; depth?: string; asset?: string } {
  let block: string | undefined;
  if (search.block !== undefined && search.block !== null && search.block !== "") {
    if (typeof search.block === "number" && Number.isSafeInteger(search.block) && search.block >= 0) block = String(search.block);
    else if (typeof search.block === "string" && /^\d+$/.test(search.block)) block = search.block;
    else throw new Error("Invalid block height. Use a non-negative whole number; quote large heights in the URL to preserve precision.");
  }
  // The block "Compare blocks" opens comparing from (a transaction that changed
  // this contract links with the one before its own). Advisory, unlike the pin:
  // a value that is not a height is dropped rather than refused.
  const before = typeof search.before === "number" && Number.isSafeInteger(search.before) && search.before >= 0 ? String(search.before)
    : typeof search.before === "string" && /^\d+$/.test(search.before) ? search.before : undefined;
  if (search.asset !== undefined && !parseTokenStateContext(search.asset)) throw new Error("Invalid asset comparison context. Reopen it from the transaction asset picker.");
  return {
    asset: typeof search.asset === "string" ? search.asset : undefined,
    block,
    before,
    tab: typeof search.tab === "string" ? search.tab : undefined,
    depth: typeof search.depth === "number" && Number.isInteger(search.depth) ? String(search.depth) : typeof search.depth === "string" ? search.depth : undefined,
    tx: typeof search.tx === "string" && /^0x[0-9a-fA-F]{64}$/.test(search.tx) ? search.tx : undefined,
    txFocus: typeof search.txFocus === "string" ? transactionFocusFromHint(search.txFocus)?.id : undefined,
  };
}
